import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";

import {
    keyRequests,
    keyRequestLoading
} from "../reducers/keyRequests.reducer";

const keyRequestReducer = combineReducers({
    keyRequests,
    keyRequestLoading
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Key Requests Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const keyRequestsStore = createStore(
    keyRequestReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const keyRequestsStoreSelectors = {
    keyRequests: (state = keyRequestsStore.getState()) => state.keyRequests,
    keyRequestLoading: (state = keyRequestsStore.getState()) =>
        state.keyRequestLoading
};

sagaMiddleware.run(rootSaga);
